module.exports = __webpack_public_path__ + "img/view.97eb937f.svg";